import { render } from "./MSource.vue?vue&type=template&id=6d5a8764&scoped=true"
import script from "./MSource.vue?vue&type=script&lang=js"
export * from "./MSource.vue?vue&type=script&lang=js"

import "./MSource.vue?vue&type=style&index=0&id=6d5a8764&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5a8764"]])

export default __exports__